import { render, staticRenderFns } from "./chateau-leoville-barton.vue?vue&type=template&id=20f3b0a5&scoped=true"
import script from "./chateau-leoville-barton.vue?vue&type=script&lang=js"
export * from "./chateau-leoville-barton.vue?vue&type=script&lang=js"
import style0 from "./chateau-leoville-barton.vue?vue&type=style&index=0&id=20f3b0a5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f3b0a5",
  null
  
)

export default component.exports